export default __webpack_public_path__ + "static/media/0021.4f5a85ab.WAV";